import React, { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'

export default function InfoToggle({ info }) {
	const [hidden, setHidden] = useState(true)

	const visibleStyle = {
		display: 'block',
	}
	const hiddenStyle = {
		display: 'none',
	}

	return (
		<div className='info-Container'>
			<div className='info-Border'>
				<div className='info-Text'>
					{ReactHtmlParser(info.infoAbbreviated)}

					{ info.infoExpanded &&
						<>
							<br />
							<button
								className='info-Button'
								onClick={() => setHidden(!hidden)}
								style={hidden ? visibleStyle : hiddenStyle}
							>
								See More
							</button>
						</>
					}
				</div>
				<div style={hidden ? hiddenStyle : visibleStyle} className='info-Text'>
					{ReactHtmlParser(info.infoExpanded)}
					<br />
					<br />
					<button className='info-Button' onClick={() => setHidden(!hidden)}>
						See Less
					</button>
				</div>
			</div>
		</div>
	)
}
